import { setEvent } from '@/EventBus'
import { isStringSet } from '@/utils'

const NotificationEvent = {
  eventName: 'set-notification',
  defaultState: {
    msgTxt: {
      type: String,
      value: '',
      default: '',
    },
    type: {
      type: String,
      value: 'info-msg',
      default: 'info-msg',
    },
    display: {
      type: Boolean,
      value: false,
      default: false,
    },
  },
  setNotification: function (message, type = 'info-msg') {
    this.defaultState.msgTxt.value = message
    this.defaultState.type.value = type
    this.defaultState.display.value = isStringSet(message)
    setEvent(this.eventName, this.defaultState)
  },
  closeNotification: function () {
    const state = this.defaultState
    Object.keys(state).forEach((key) => (state[key].value = state[key].default))
    setEvent(this.eventName, state)
  },
}

export default NotificationEvent
